import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TimesheetService } from '../components/timesheet-final/services/timesheet.service';
import { PmTimesheetService } from '../components/PM_timesheet_view/services/pm-timesheet.service';
import { applyRmTimesheetDeepLinkFromUrl } from '../components/timesheet-final/utils/apply-rm-timesheet-deep-link';
import { SnackbarService } from '../services/snack-service/snackbar-service';

/**
 * Applies RM approval email deep-link query params before the lazy child route loads.
 * URL: `/dashboard/timesheet/approval-timsheet?employeeId=&startDate=&endDate=&projectType=`
 */
export const rmTimesheetDeepLinkGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const timesheetShell = inject(TimesheetService);
  const pm = inject(PmTimesheetService);
  const snackbar = inject(SnackbarService);
  applyRmTimesheetDeepLinkFromUrl(router, timesheetShell, pm, state.url, snackbar);
  return true;
};
